import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { listNotifications } from '@/services/notificationApi';

/**
 * Fetch the current user's notification list on demand.
 *
 * - Only enabled when `enabled` is true (i.e., when the dropdown is open).
 * - staleTime of 10 s prevents redundant refetches on rapid open/close.
 * - query key includes user.id to isolate caches across user switches.
 * - 401 responses stop retries immediately.
 */
export function useNotificationList(enabled: boolean) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['notification-list', user?.id],
    queryFn: () => listNotifications({ limit: 20 }),
    enabled: enabled && !!user?.id,
    staleTime: 10_000,
    retry: (failureCount, error) => {
      if (isAxiosError(error) && error.response?.status === 401) return false;
      return failureCount < 2;
    },
  });
}
